export default "__VITE_ASSET__DopJ1xCu__"